
import './App.css';
import { OnboardingPage } from './Pages/OnboardingPage/OnbordingPage';

function App() {
  return (
    <div className='app'>
      <OnboardingPage/>
    </div>
  );
}

export default App;
